import React from 'react';
import { MDBCard, MDBCardTitle, MDBCardText, MDBFormInline, MDBBadge, MDBContainer, MDBListGroup, MDBListGroupItem, MDBRow, MDBCol, MDBBtn, MDBIcon } from 'mdbreact';
import DataLayer from '../Utilities/DataLayer';
import Header from './ComponentFragments/Header';
import WatchListCard from './ComponentFragments/WatchListCard';

export default class WatchList extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            watchListData: [],
            filteredData: []
        }
        this.removeFromList = this.removeFromList.bind(this);
        this.getWatchList = this.getWatchList.bind(this);
        this.searchList = this.searchList.bind(this);
    }

    searchList(phrase) {
        let arr = this.state.watchListData.filter((dem) => (dem.demName.toUpperCase().includes(phrase.toUpperCase())) || (dem.unitName.toUpperCase().includes(phrase.toUpperCase())))
        this.setState({ filteredData: arr });
    }

    removeFromList() {
        this.setState({
            watchListData: [],
            filteredData: []
        })
        this.getWatchList();
    }
    
    componentWillMount() {
        this.getWatchList();
    }

    async getWatchList() {
        this.props.loaderOn();
        var dl = new DataLayer();

        await dl.Get('/common/getwatchlist', 200).then((response) => {
            var test = "";
            this.setState({
                watchListData: response.data,
                filteredData: response.data
            });
            this.props.loaderOff();
        })
    }

     render() {
        return (
            <div>
                <Header headerText="Watch List"
                    placeholderText="Search Watch List"
                    searchList={this.searchList}
                />
                
                    <MDBRow>
                        {
                        this.state.filteredData.map((watch) => {
                                return (
                                    <MDBCol xl="3" lg="6" md="6" sm="12" className="mb-r" >
                                        <WatchListCard {...this.props}
                                            unitName={watch.unitName}
                                            demName={watch.demName}
                                            telephoneCell={watch.telephoneCell}
                                            sfCurrentCode={watch.sfCurrentCode}
                                            status={watch.status}
                                            sfId={watch.sfId}
                                            unitId={watch.unitId}
                                            removeFromList={this.removeFromList}
                                            statusCode1={watch.statusCode1}
                                            
                                    />
                                    </MDBCol>
                                );
                            })
                        }
                    </MDBRow>
                
            </div>
        );
    }
}